export enum EKeyPersonnelAppointment {
  KEYMAN = 'KEYMAN',
  SHAREHOLDER = 'SHAREHOLDER',
  DIRECTOR = 'DIRECTOR',
  GUARANTOR = 'GUARANTOR',
  SECRETARY = 'SECRETARY',
}

export const KeyPersonnelAppointment = {
  [EKeyPersonnelAppointment.KEYMAN]: 'Keyman',
  [EKeyPersonnelAppointment.SHAREHOLDER]: 'Shareholder',
  [EKeyPersonnelAppointment.DIRECTOR]: 'Director',
  [EKeyPersonnelAppointment.GUARANTOR]: 'Guarantor',
  [EKeyPersonnelAppointment.SECRETARY]: 'Secretary',
};
export type KEY_PERSONNEL_APPOINTMENT = keyof typeof EKeyPersonnelAppointment;

export enum EKeyPersonnelRelationshipToApplicant {
  DIRECTOR = 'DIRECTOR',
  PARTNER = 'PARTNER',
  SOLE_PROPRIETOR = 'SOLE_PROPRIETOR',
  SHAREHOLDER = 'SHAREHOLDER',
  SECRETARY = 'SECRETARY',
  OTHER = 'OTHER',
}

export const KeyPersonnelRelationshipToApplicant = {
  [EKeyPersonnelRelationshipToApplicant.DIRECTOR]: 'Director',
  [EKeyPersonnelRelationshipToApplicant.PARTNER]: 'Partner',
  [EKeyPersonnelRelationshipToApplicant.SOLE_PROPRIETOR]: 'Sole-Proprietor',
  [EKeyPersonnelRelationshipToApplicant.SHAREHOLDER]: 'Shareholder',
  [EKeyPersonnelRelationshipToApplicant.SECRETARY]: 'Secretary',
  [EKeyPersonnelRelationshipToApplicant.OTHER]: 'Others',
};
export type KEY_PERSONNEL_RELATIONSHIP_TO_APPLICANT = keyof typeof EKeyPersonnelRelationshipToApplicant;

export enum EKeyPersonnelTypeOfResidence {
  LANDED = 'LANDED',
  PRIVATE_APARTMENT_OR_CONDOMINIUM = 'PRIVATE_APARTMENT_OR_CONDOMINIUM',
  EXECUTIVE_CONDO_OR_HUDC = 'EXECUTIVE_CONDO_OR_HUDC',
  HDB = 'HDB',
}

export const KeyPersonnelTypeOfResidence = {
  [EKeyPersonnelTypeOfResidence.LANDED]: 'Landed',
  [EKeyPersonnelTypeOfResidence.PRIVATE_APARTMENT_OR_CONDOMINIUM]: 'Private Apartment/Condominium',
  [EKeyPersonnelTypeOfResidence.EXECUTIVE_CONDO_OR_HUDC]: 'Executive Condo/HUDC',
  [EKeyPersonnelTypeOfResidence.HDB]: 'HDB',
};
export type KEY_PERSONNEL_TYPE_OF_RESIDENCE = keyof typeof EKeyPersonnelTypeOfResidence;

export enum EKeyPersonnelRace {
  CHINESE = 'CHINESE',
  MALAY = 'MALAY',
  INDIAN = 'INDIAN',
  EURASIAN = 'EURASIAN',
  OTHER = 'OTHER',
}

export const KeyPersonnelRace = {
  [EKeyPersonnelRace.CHINESE]: 'Chinese',
  [EKeyPersonnelRace.MALAY]: 'Malay',
  [EKeyPersonnelRace.INDIAN]: 'Indian',
  [EKeyPersonnelRace.EURASIAN]: 'Eurasian',
  [EKeyPersonnelRace.OTHER]: 'Others',
};
export type KEY_PERSONNEL_RACE = keyof typeof EKeyPersonnelRace;

export enum EKeyPersonnelOwnership {
  OWNED_FULLY_PAID = 'OWNED_FULLY_PAID',
  OWNED_MORTGAGED = 'OWNED_MORTGAGED',
  PARENT_HOUSE = 'PARENT_HOUSE',
  RENTED = 'RENTED',
  OTHER = 'OTHER',
}

export const KeyPersonnelOwnership = {
  [EKeyPersonnelOwnership.OWNED_FULLY_PAID]: 'Owned (fully Paid)',
  [EKeyPersonnelOwnership.OWNED_MORTGAGED]: 'Owned (Mortgaged)',
  [EKeyPersonnelOwnership.PARENT_HOUSE]: `Parent's House`,
  [EKeyPersonnelOwnership.RENTED]: 'Rented',
  [EKeyPersonnelOwnership.OTHER]: 'Others',
};
export type KEY_PERSONNEL_OWNERSHIP = keyof typeof EKeyPersonnelOwnership;

export enum EGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export const Gender = {
  [EGender.MALE]: 'Male',
  [EGender.FEMALE]: 'Female',
};
export type GENDER = keyof typeof EGender;

export enum ECBSRiskGrade {
  AA = 'AA',
  BB = 'BB',
  CC = 'CC',
  DD = 'DD',
  EE = 'EE',
  FF = 'FF',
  GG = 'GG',
  HH = 'HH',
  HX = 'HX',
  HZ = 'HZ',
  GX = 'GX',
  BX = 'BX',
  CX = 'CX',
}

export type CBS_RISK_GRADE = keyof typeof ECBSRiskGrade;

export enum EMaxDelqL6M {
  A = 'A',
  B = 'B',
  C_OR_WORSE = 'C_OR_WORSE',
}

export const MaxDelqL6M = {
  [EMaxDelqL6M.A]: 'A',
  [EMaxDelqL6M.B]: 'B',
  [EMaxDelqL6M.C_OR_WORSE]: 'C or Worse',
};
export type CBS_MAX_DELQ_L6M = keyof typeof EMaxDelqL6M;

export enum EKeyPersonnelResidencialStatus {
  CITIZEN = 'CITIZEN',
  PERMANENT_RESIDENT = 'PERMANENT_RESIDENT',
  FOREIGNER = 'FOREIGNER',
}

export type KEY_PERSONNEL_RESIDENCIAL_STATUS = keyof typeof EKeyPersonnelResidencialStatus;

export const SUBMISSION_SOURCE = ['manual', 'singpass'] as const;

export type SubmissionSource = typeof SUBMISSION_SOURCE[number];

export enum EKeyPersonnelAttachmentSection {
  CBS = 'CBS',
  GENERAL = 'GENERAL',
  GP6 = 'GP6',
}

export enum EKeyPersonnelAttachmentKey {
  CPF = 'CPF',
  SIGNATURE = 'SIGNATURE',
  NOTICE_OF_ASSESSMENT = 'NOTICE_OF_ASSESSMENT',
  CREDIT_CHECK = 'CREDIT_CHECK',
}

export enum EKeyPersonnelMaritalStatus {
  SINGLE = 'SINGLE',
  MARRIED = 'MARRIED',
  WIDOWED = 'WIDOWED',
  DIVORCED = 'DIVORCED',
}

export const KeyPersonnelMaritalStatus = {
  [EKeyPersonnelMaritalStatus.SINGLE]: 'Single',
  [EKeyPersonnelMaritalStatus.MARRIED]: 'Married',
  [EKeyPersonnelMaritalStatus.WIDOWED]: 'Widowed',
  [EKeyPersonnelMaritalStatus.DIVORCED]: 'Divorced',
};
export type KEY_PERSONNEL_MARITAL_STATUS = keyof typeof EKeyPersonnelMaritalStatus;

export enum EKeyPersonnelAddressType {
  RESIDENTIAL_ADDRESS = 'RESIDENTIAL_ADDRESS',
  MAILING_ADDRESS = 'MAILING_ADDRESS',
}

export type KEY_PERSONNEL_ADDRESS_TYPE = keyof typeof EKeyPersonnelAddressType;

export enum EKeyPersonnelTag {
  BENEFICIAL_OWNER = 'BENEFICIAL_OWNER',
  US_PERSON = 'US_PERSON',
}

export const KeyPersonnelTags = [EKeyPersonnelTag.BENEFICIAL_OWNER, EKeyPersonnelTag.US_PERSON] as const;

export type KEY_PERSONNEL_TAG = typeof KeyPersonnelTags[number];

export type KEY_PERSONNEL_METADATA = {
  tags?: EKeyPersonnelTag[];
  uuid?: string;
};

export enum EAddressSubType {
  LOCAL = 'LOCAL',
  FOREIGN = 'FOREIGN',
}

export type ADDRESS_SUB_TYPE = keyof typeof EAddressSubType;
